import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/liquidaciones';
import BoletaLiquidacion from './BoletaLiquidacion';


const ms2p = (state) => {
  return {
    ...state.liquidaciones,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(BoletaLiquidacion);
